import { hasPermission } from '@/core/composables'
import type { TPurchaseOrderType } from './api/queries'

export const PO_CREATE_PERMISSIONS = {
  normal: 'purchase_orders.create.normal',
  additive: 'purchase_orders.create.additive',
  deductive: 'purchase_orders.create.deductive',
} as const satisfies Record<TPurchaseOrderType, string>

export const PO_APPROVE_PERMISSIONS = {
  normal: 'purchase_orders.approve.normal',
  additive: 'purchase_orders.approve.additive',
  deductive: 'purchase_orders.approve.deductive',
} as const satisfies Record<TPurchaseOrderType, string>

export const PO_CREATE_ANY = Object.values(PO_CREATE_PERMISSIONS)

export const PO_APPROVE_ANY = Object.values(PO_APPROVE_PERMISSIONS)

export const canCreatePoType = (type: string): boolean => {
  const key = PO_CREATE_PERMISSIONS[type as TPurchaseOrderType]
  if (!key) return false
  return hasPermission({ permission: key })
}

export const canApprovePoType = (type: string): boolean => {
  const key = PO_APPROVE_PERMISSIONS[type as TPurchaseOrderType]
  if (!key) return false
  return hasPermission({ permission: key })
}

export const canCreateAnyPo = (): boolean =>
  hasPermission({ permission: PO_CREATE_ANY })

export const canApproveAnyPo = (): boolean =>
  hasPermission({ permission: PO_APPROVE_ANY })

export const canCreatePoAttachment = (): boolean =>
  hasPermission({ permission: 'purchase_orders.attachments.create' })

export const canDeletePoAttachment = (): boolean =>
  hasPermission({ permission: 'purchase_orders.attachments.delete' })
